// Dependencies
import React from 'react';
import radium from 'radium';
import Section from '../../components/section/Section.jsx';
import { ThemeContext } from '../../components/theme/Theme.jsx';

function CustomInfoBox(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		box: {
			margin: context.themeManager
				.value('event-additional-info-box', 'margin-mobile', 'section-margin-mobile'),
			padding: '2em 0',
			backgroundColor: context.themeManager.value('event-additional-info-box',
				'backgroundColor', 'bg-color-box'),
			'@media(min-width : 768px)': {
				margin: context.themeManager
					.value('event-additional-info-box', 'margin-mobile', 'section-margin-desktop'),
			},
		},

		innerBox: {
			lineHeight: context.themeManager.value('event-additional-info-box', 'lineHeight', 'line-height-200'),
			'@media(min-width : 768px)': {
				padding: '2em 0',
			},
		},
	};

	const htmlText = context.themeManager.getThemeText(props.textPoperty);

	return (
		<div>
			{htmlText
				? <Section style={style.box}>
					<div
						style={style.innerBox}
						dangerouslySetInnerHTML={{ __html: htmlText }}
					/>
				</Section>
				: ''
			}
		</div>
	);
}

export default radium(CustomInfoBox);
